module.exports = __webpack_public_path__ + "assets/img/229f01ca00ea5bb54da7564f414509f4.svg";